import { IconRefresh, IconSearch } from "@tabler/icons-react"
import { ButtonType } from "../../../../Utilities/Enums/ButtonTypeEnum"
import CustomButton from "../../../Elements/CustomButton"
import { Stack } from "@mui/material"

export const CustomListSearchResetBtns = (props: { onClickSearch: () => void, onClickReset: () => void}) => {
    return <Stack direction='row' spacing={1}>
        <CustomButton title='Search'
            startIcon={<IconSearch size={18}/>}
            onClick={props.onClickSearch}
            btnType={ButtonType.PRIMARY} />
        <CustomButton title='Reset'
            startIcon={<IconRefresh size={18}/>}
            onClick={props.onClickReset}
            btnType={ButtonType.CANCEL} />
    </Stack>
}